export default function Experience() {
  return (
    <section id="experience" className="bg-gray-900 py-12 px-6 text-white">
      <h3 className="text-3xl text-red-500 font-bold text-center mb-10">Experience</h3>
      <div className="max-w-6xl mx-auto bg-gray-900 p-6 rounded shadow-md">
        <h4 className="text-xl font-semibold text-red-400 mb-1">AI Engineer Intern</h4>
        <p className="text-sm text-gray-400 mb-4">
          January 2025 – April 2025 | OSCOWL AI, UK (Remote)
        </p>
        <ul className="list-disc list-inside text-gray-200 space-y-2 pl-4">
          <li>
            Specialized in fine-tuning, training, and deploying Large Language Models (LLMs) and other ML algorithms on Azure Cloud.
          </li>
          <li>
            Developed Python-based AI workflows and optimized model performance for scalability and efficiency.
          </li>
          <li>
            Integrated innovative AI solutions into scalable applications across cloud infrastructure.
          </li>
        </ul>
      </div>
      <section className="text-center mt-3">
      <a
        href="/Chandu_experience_letter.pdf"
        download
        className="bg-red-600 px-6 py-3 rounded hover:bg-red-700 transition"
      >
        Download My Experience Letter
      </a>
      </section>
    </section>
  );
}
